import React from 'react';
import intl from 'react-intl-universal';
import Page from '../default-v2/Page';
import CardHeader from '../default-v2/CardHeader';
import Breadcrumb from '../../components/Breadcrumbs';
import userImg from '../../assets/img/users.svg';
import MonitoringNotificationPreferences from './MonitoringNotificationPreferences';

function MonitoringNotificationPreferencesPage() {
  const aPages = [
    {
      cName: 'MyProfile.title',
      cLink: '/my-account/my-profile'
    },
    {
      cName: 'Monitoring.notification_preferences.title',
      cLink: undefined
    }
  ];

  return (
    <Page
      loading={0}
      rcmpBreadcrumb={<Breadcrumb aPages={aPages} />}
      cTitle={intl.get('Monitoring.notification_preferences.title')}
      cImage={userImg}
      rcmpCardHeader={<CardHeader />}
      className="v2-my-profile"
    >
      <MonitoringNotificationPreferences />
    </Page>
  );
}

export default MonitoringNotificationPreferencesPage;
